<div class="row">
  <div class="col-6 div__pontos_expirar">
    <dynamic-form [fields]="regLabelsEconomizados"></dynamic-form>
  </div>
  <div class="col-6 div__economizado">
    <dynamic-form [fields]="regLabelsPontosAExpirar"></dynamic-form>
  </div>
</div>
